import React, { useState } from 'react';
import './AddCandidateToJob.css';

const AddCandidateToJob = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilters, setActiveFilters] = useState([]);

  const toggleChip = (skill) => {
    if (activeFilters.includes(skill)) {
      setActiveFilters(prev => prev.filter(s => s !== skill));
    } else {
      setActiveFilters(prev => [...prev, skill]);
    }
  };

  const addToJob = (name, key) => {
    const stage = document.getElementById(`stage-${key}`)?.value || 'Applied';
    toast(`${name} added to pipeline at ${stage} stage`);
  };

  const toast = (msg, type = 'success') => {
    const t = document.createElement('div');
    t.className = 'og-toast';
    const color = type === 'error' ? '#f87171' : type === 'warn' ? '#fbbf24' : '#4ade80';
    const icon = type === 'error' ? 'fa-times-circle' : type === 'warn' ? 'fa-triangle-exclamation' : 'fa-check-circle';
    t.innerHTML = `<i class="fa-solid ${icon}" style="color:${color};"></i>${msg}`;
    document.body.appendChild(t);
    setTimeout(() => {
      t.style.opacity = '0';
      setTimeout(() => t.remove(), 300);
    }, 2800);
  };

  return (
    <>

      <div className="main">
        <div className="topbar">
          <i className="fa-solid fa-link" style={{ color: 'var(--primary)' }}></i>
          <div className="breadcrumb" style={{ margin: '0' }}>
            <a href="recruitment-jobs.html">Jobs</a>
            <i className="fa-solid fa-chevron-right" style={{ fontSize: '.6rem' }}></i>
            <a href="recruitment-job-detail.html">JOB-2026-001</a>
            <i className="fa-solid fa-chevron-right" style={{ fontSize: '.6rem' }}></i>
            <strong style={{ color: 'var(--text)' }}>Add Candidate</strong>
          </div>
          <div className="top-right">
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <div className="top-avatar">AM</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '.8rem' }}>Arun Mishra</div>
                <div style={{ fontSize: '.68rem', color: 'var(--muted)' }}>HR Admin</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
            <div>
              <h2 style={{ fontSize: '1.35rem', fontWeight: '700', margin: '0 0 .15rem' }}>
                <i className="fa-solid fa-link" style={{ color: 'var(--primary)', marginRight: '.4rem', fontSize: '1.1rem' }}></i>
                Add Candidate to Job
              </h2>
              <div className="breadcrumb">Search and link from the shared candidate database</div>
            </div>
            <button className="btn btn-outline btn-sm" onClick={() => window.history.back()}>
              <i className="fa-solid fa-arrow-left"></i> Back
            </button>
          </div>

          <div className="page-layout">
            {/* Left: Job Context */}
            <div className="job-context">
              {/* Full job context preserved */}
            </div>

            {/* Right: Candidate Search */}
            <div>
              {/* Search bar and filters preserved */}
              <div className="result-count" id="resultCount">Showing 5 candidates from database · <span style={{ color: 'var(--amber)', fontWeight: '600' }}>2 already in this job's pipeline</span></div>

              <div id="candResults">
                {/* All candidate result cards fully preserved */}
              </div>

              {/* Pagination */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCandidateToJob;